<template>
  <div class="form-group">
    <label class="custom-label">{{labelDesc}}</label>
    <div>
      <label class="label-range-custom" style="display: block">
        {{$t('ct-padding-left-right')}}
        <div style="display: inline-flex;">
          <input type="range" class="custom-range" :min="min" :max="max" step="1" v-model="l"
                 @change="changeValueDouble"
                 @mousemove="changeValueDouble" style="margin-left: 0;width: 140px !important;">
          <input type="number" class="custom-input form-control " v-model="l" :min="min" :max="max" step="1"
                 @change="changeValueDouble" @keyup="changeValueDouble" @mouseover="changeValueDouble">
        </div>
      </label>
    </div>
    <div>
      <label class="label-range-custom">
        {{$t('ct-padding-left')}}
        <input type="range" class="custom-range" :min="min" :max="max" step="1" v-model="l" @change="changeValue"
               @mousemove="changeValue" style="margin-left: 35px;">
        <input type="number" class="custom-input form-control " v-model="l" :min="min" :max="max" step="1"
               @change="changeValue" @keyup="changeValue" @mouseover="changeValue">
      </label>
    </div>
    <div>
      <label class="label-range-custom">
        {{$t('ct-padding-right')}}
        <input type="range" class="custom-range" :min="min" :max="max" step="1" v-model="r" @change="changeValue"
               @mousemove="changeValue" style="margin-left: 25px;">
        <input type="number" class="custom-input form-control " v-model="r" :min="min" :max="max" step="1"
               @change="changeValue" @keyup="changeValue" @mouseover="changeValue">
      </label>
    </div>
    <div>
      <label class="label-range-custom">
        {{$t('ct-padding-top')}}
        <input type="range" class="custom-range" :min="min" :max="max" step="1" v-model="t" @change="changeValue"
               @mousemove="changeValue" style="margin-left: 35px;">
        <input type="number" class="custom-input form-control " v-model="t" :min="min" :max="max" step="1"
               @change="changeValue" @keyup="changeValue" @mouseover="changeValue">
      </label>
    </div>
    <div>
      <label class="label-range-custom">
        {{$t('ct-padding-bottom')}}
        <input type="range" class="custom-range" :min="min" :max="max" step="1" v-model="b" @change="changeValue"
               @mousemove="changeValue">
        <input type="number" class="custom-input form-control " v-model="b" :min="min" :max="max" step="1"
               @change="changeValue" @keyup="changeValue" @mouseover="changeValue">
      </label>
    </div>
  </div>

</template>

<script>

export default {
  name: 'PaddingComponent',
  data() {
    return {
      element: null,
      l: 5,
      r: 5,
      t: 5,
      b: 5,
      labelDesc: 'padding',
      callback: null,
      min: 0,
      max: 150,
    }
  },
  methods: {
    changeValueDouble() {
      if (this.l < this.min)
        this.l = this.min;
      this.r = this.l;

      this.changeValue();
    },
    changeValue() {
      if (this.l < this.min)
        this.l = this.min;
      if (this.r < this.min)
        this.r = this.min;
      if (this.t < this.min)
        this.t = this.min;
      if (this.b < this.min)
        this.b = this.min;
          
      let response = {
        paddingTop: this.t,
        paddingLeft: this.l,
        paddingRight: this.r,
        paddingBottom: this.b
      };

      this.callback(response);
    },
    setValues(obj) {
      this.l = parseInt(obj.defaultLeft);
      this.r = parseInt(obj.defaultRight);
      this.t = parseInt(obj.defaultTop);
      this.b = parseInt(obj.defaultBottom);

      this.min = parseInt(obj.min);
      this.max = parseInt(obj.max);
      this.labelDesc = this.$t(`ct-${obj.labelDesc}`);

      this.callback = obj.callback;
    }
  },
}

</script>

<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }

  .label-range-custom {
    display: inline-flex;
    width: 250px;
    margin-top: 10px;
  }

  .custom-range {
    width: 85px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .custom-input {
    margin-top: -10px;
    width: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resource_components/Padding.vue